import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/routing/rootRoute.ts';
import AcceptInvitationPage from '@/features/public/acceptInvitation/pages/AcceptInvitationPage.tsx';

const searchSchema = z.object({
  token: z.string(),
});

export const acceptInvitationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accept-invitation',
  component: AcceptInvitationPage,
  validateSearch: searchSchema,
});
